import { Action, createReducer, on } from "@ngrx/store";
import * as fromAssignSettingsActions from "../actions/assign-settings.action";
import { GlobalDateSettingsInterface } from "#models/AssignReview/global-date-settings.interface";
import { AutoProgressAssignablesInterface } from "#models/AssignReview/auto-progress-assignables.interface";
import { MaxAttemptsAssignablesInterface } from "#models/AssignReview/max-attempts-assignables.interface";

export interface AssignSettingsState {
    globalDateSettings: GlobalDateSettingsInterface | null;
    globalAutoProgress: boolean;
    autoProgressAssignables: AutoProgressAssignablesInterface[];
    globalMaxAttempts: number | null;
    maxAttemptsAssignables: MaxAttemptsAssignablesInterface[];
    globalLanguageOptions: number;
}

export const initialState: AssignSettingsState = {
    globalDateSettings: null,
    globalAutoProgress: false,
    autoProgressAssignables: [],
    globalMaxAttempts: null,
    maxAttemptsAssignables: [],
    globalLanguageOptions: 0,
};
const assignSettingsReducer = createReducer(
    initialState,
    on(
        fromAssignSettingsActions.setGlobalDateSettings,
        (state, { payload }) => {
            return {
                ...state,
                globalDateSettings: payload,
            };
        }
    ),
    on(
        fromAssignSettingsActions.setGlobalAutoProgress,
        (state, { payload }) => {
            return {
                ...state,
                globalAutoProgress: payload,
            };
        }
    ),
    on(
        fromAssignSettingsActions.setAutoProgressAssignables,
        (state, { payload }) => {
            return {
                ...state,
                autoProgressAssignables: payload,
            };
        }
    ),
    on(fromAssignSettingsActions.clearAutoProgressAssignables, (state) => {
        return {
            ...state,
            autoProgressAssignables: [],
        };
    }),
    on(
        fromAssignSettingsActions.setGlobalLanguageOptions,
        (state, { payload }) => {
            return {
                ...state,
                globalLanguageOptions: payload,
            };
        }
    ),
    on(fromAssignSettingsActions.setGlobalMaxAttempts, (state, { payload }) => {
        return {
            ...state,
            globalMaxAttempts: payload,
        };
    }),
    on(
        fromAssignSettingsActions.setMaxAttemptsAssignables,
        (state, { payload }) => {
            return {
                ...state,
                maxAttemptsAssignables: payload,
            };
        }
    )
);
export function reducer(
    state: AssignSettingsState | undefined,
    action: Action
) {
    return assignSettingsReducer(state, action);
}

export const getGlobalDateSettings = (state: AssignSettingsState) =>
    state.globalDateSettings;
export const getGlobalAutoProgress = (state: AssignSettingsState) =>
    state.globalAutoProgress;
export const getAutoProgressAssignables = (state: AssignSettingsState) =>
    state.autoProgressAssignables;
export const getGlobalMaxAttempts = (state: AssignSettingsState) =>
    state.globalMaxAttempts;
export const getGlobalLanguageOptions = (state: AssignSettingsState) =>
    state.globalLanguageOptions;
export const getMaxAttemptsAssignables = (state: AssignSettingsState) =>
    state.maxAttemptsAssignables;
